import { apiUrl, currentUserId, currentUserQuery } from "./auth";
import type { TaskKind } from "./suivi";

export type RelanceStep = { days: number; kind: TaskKind; title: string; time: string };
export type RelanceSequence = { code: string; name: string; steps: RelanceStep[] };

export const RELANCE_KINDS: { value: TaskKind; label: string }[] = [
  { value: "call", label: "Appeler" },
  { value: "quote", label: "Devis" },
  { value: "unpaid", label: "Impayé" },
  { value: "meeting", label: "RDV" },
];

function headers(json = false): HeadersInit {
  return {
    ...(currentUserId() ? { "X-User-Id": currentUserId() } : {}),
    ...(json ? { "Content-Type": "application/json" } : {}),
  };
}

export async function loadSequences(): Promise<RelanceSequence[]> {
  const res = await fetch(apiUrl("sequences.php") + currentUserQuery(), {
    credentials: "include",
    cache: "no-store",
    headers: headers(),
  });
  const data = (await res.json().catch(() => ({}))) as { success?: boolean; message?: string; sequences?: RelanceSequence[] };
  if (!res.ok || data.success === false || !data.sequences) {
    throw new Error(data.message || "Séquences indisponibles");
  }
  return data.sequences;
}

export async function saveSequences(sequences: RelanceSequence[]): Promise<RelanceSequence[]> {
  const res = await fetch(apiUrl("sequences.php") + currentUserQuery(), {
    method: "POST",
    credentials: "include",
    cache: "no-store",
    headers: headers(true),
    body: JSON.stringify({ sequences }),
  });
  const data = (await res.json().catch(() => ({}))) as { success?: boolean; message?: string; sequences?: RelanceSequence[] };
  if (!res.ok || data.success === false || !data.sequences) {
    throw new Error(data.message || "Séquences non enregistrées");
  }
  return data.sequences;
}
